import { TabItem, Tabs } from "@aws-amplify/ui-react";
import LocalizedStrings from "react-localization";

import usePermissions from "hooks/usePermission";
import { Alerts, AlertLogs } from ".";

const AlertsTab = () => {
  const [canReadConfig, canRead] = usePermissions([
    "alert:read-config",
    "alert:read",
  ]);
  return (
    <Tabs>
      {canRead && (
        <TabItem title={strings.alerts}>
          <div className="m-4">
            <AlertLogs />
          </div>
        </TabItem>
      )}
      {canReadConfig && (
        <TabItem title={strings.alertsConfig}>
          <div className="m-4">
            <Alerts />
          </div>
        </TabItem>
      )}
    </Tabs>
  );
};

const strings = new LocalizedStrings({
  es: {
    alertsConfig: "Configuración de Alertas",
    alerts: "Alertas",
  },
});

export default AlertsTab;
